import { Component, OnInit, Inject, Injector, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { GlobalObjectsService } from 'src/app/shared/services/global-objects.service';
import { CommonService } from 'src/app/core/services';
import { NgbDropdown, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { JwtHelper } from 'src/app/core/guards/jwt.helper';
import { NavigationEnd, Router } from '@angular/router';
import { BootstrapRequestContext } from 'tbs-typings';
import { TBSBaseComponent } from 'src/app/shared/models/tbsBaseComponent';
import { filter, take, takeUntil } from 'rxjs/operators';
import { UIConfigurationType } from 'src/app/shared/models/uiconfigration.interface';
import { UiconfigrationService } from 'src/app/core/services/uiconfigration.service';
import { ChildComponentOptions } from 'src/app/shared/models/childComponentOptions.model';
import { Constants, SessionStorageKey } from 'src/app/shared/models/constants';
import { IEditableMBRSiteToolbar } from 'src/app/shared/editable-mbr-site-toolbar/editable-mbr-site-toolbar.model';
import { SelfServiceService } from '../self-service.service';
import { SelfServicePopulationSelectorTemplateModalComponent } from 'src/app/shared/self-service-templates/self-service-population-selector-template-modal/self-service-population-selector-template-modal.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UiConfigModalComponent } from '../../global-benefits-library/ui-config-modal/ui-config-modal.component';
import { MastheadService } from 'src/app/core/services/masthead.service';
import { EditableMbrSiteToolbarService } from 'src/app/shared/editable-mbr-site-toolbar/editable-mbr-site-toolbar.service';
@Component({
  selector: 'app-self-service-masthead',
  templateUrl: './self-service-masthead.component.html',
  standalone: false
})
export class SelfServiceMastheadComponent extends TBSBaseComponent implements OnInit, OnDestroy {
  isAuthenticated: boolean;
  isNavbarCollapsed = true;
  preferredName: string;
  resourcestrings = {};
  headMenuObject: any;
  mobileMaxWidth = 576; //Max scree size for mobile
  isMobile = false;
  TID: string;
  isFailedPayment: boolean;
  uiConfig: UIConfigurationType;
  isFromMobileApp: boolean;
  hasGracePeriod: boolean;
  isImpersonation: string;
  dropDownAutoClose: boolean | string = true;
  disableDropDownAutoClose: boolean = false;
  @ViewChildren(NgbDropdown) dropdowns: QueryList<NgbDropdown>;
  modalOption: NgbModalOptions = {};
  siteTheme: string;
  isInternalEditorSite = false;
  toolbarControlsForMasthead: IEditableMBRSiteToolbar.Controls;
  public readonly ToolbarType = IEditableMBRSiteToolbar.ToolbarType;

  constructor(
    @Inject('BootstrapRequestContext') private readonly bootstrapRequestContext: BootstrapRequestContext,
    private readonly injector: Injector,
    public authenticationService: AuthenticationService,
    public commonService: CommonService,
    private readonly modalService: NgbModal,
    private readonly globalObjectsService: GlobalObjectsService,
    private readonly router: Router,
    private readonly uiconfigrationService: UiconfigrationService,
    private readonly selfServiceService: SelfServiceService,
    private readonly ngxService: NgxUiLoaderService,
    public readonly mastheadService: MastheadService,
    private readonly editableMbrSiteToolbarService: EditableMbrSiteToolbarService
  ) {
    super(injector, new ChildComponentOptions(true, true, false));
    this.addResourceStringKeys(this.resService.mastheadStringKeys);
    this.addResourceStringKeys(this.resService.homeStringKeys);
    this.headMenuObject = JSON.parse(bootstrapRequestContext.mastheadMenu);
    this.isInternalEditorSite = this.helperService.isInternalEditorSite;
    this.loadResourceStringAsObservable()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.getResouceStringsAsObject(res);
        let population = this.globalObjectsService.currentSelectedPopulationName.value;
        if (!population) {
          this.globalObjectsService.compactEmployeeInformation.subscribe(data => {
            if (data && data.populations.length > 0) {
              const populations = this.globalObjectsService.Populations.filter(x => x.recordID == data.populations[0].recordID);
              
              if (populations && populations.length > 0) {
                this.loadToolBarControls(populations[0].name);
              } else {
               this.loadToolBarControls('');
              }
            } else {
              this.loadToolBarControls(population);
            }
          });
        } else {
          this.loadToolBarControls(population);
        }
      });

    this.globalObjectsService.Products
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(r => {
        this.mastheadService.initBenefitsList(this.commonService.getUniqueProductsFromProductList(r));
      });
  }
  toggleNavBar() {
    this.helperService.narBarCollapseState.next(!this.isNavbarCollapsed)
  }

  async ngOnInit(): Promise<void> {
    let isCurrentUserSubscribed = false;
    this.globalObjectsService.checkHeaderFooterConfig.subscribe(value => {
      if (value) {
        this.helperService.narBarCollapseState.subscribe((isCollapsed) => {
          this.isNavbarCollapsed = isCollapsed;
        });
        this.uiConfig = this.uiconfigrationService.getUIConfiguration();
        this.siteTheme = this.uiConfig?.uiConfiguration?.presetTheme;
        this.isFromMobileApp = sessionStorage.getItem(SessionStorageKey.IsFromMobileApp) === 'true';
        this.getCurrentPathRoleSettingStatus(this.injector);

        //currentUser does not unsubscribe as masthead component is always available and ngdestroyed not triggered 
        //because of this globalcartbenefits api called many times
        //So flag check for prevent current user subsription multiple times
        if (!isCurrentUserSubscribed) {
          this.authenticationService.currentUser
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((user) => {
              this.isAuthenticated = this.authenticationService.isLogin;
              isCurrentUserSubscribed = true;
              if (user?.id_token) {
                const jwtHelper = new JwtHelper();
                const decodedUser = jwtHelper.decodeToken(user.id_token);

                this.updateAnalyticsValues(decodedUser);
                this.globalObjectsService.reloadShoppingCart.next(true);
                this.globalObjectsService.reloadProfileGracePeriod.next(true);
              }
            });
        }
        this.globalObjectsService.compactEmployeeInformation
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(emp => {
            if (this.authenticationService.isLogin) {
              this.preferredName = emp?.preferredName;
            }
          });

        this.getScreenView();
      }
      if (this.helperService.isLoggedOn()) {
        const jwtHelper = new JwtHelper();
        const user = JSON.parse(sessionStorage.getItem('currentUser'));
        this.isImpersonation = jwtHelper.decodeToken(user.id_token).IsImpersonation;
      }

    });

    if (!this.globalObjectsService.currentSelectedPopulationName.value && this.helperService.isLoggedOn()) {
      await this.selfServiceService.getExistingPopulationForEmployee();
    }
    
    this.loadCategories();
    this.selfServiceService.onPopulationPreviewChange
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(() => this.loadCategories());

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe)
      )
      .subscribe(() => {
        this.loadToolBarControls(this.globalObjectsService.currentSelectedPopulationName.value);
      });
  }

  public loadCategories(): void {
    this.ngxService.start('LOAD_CATEGORIES');
    this.commonService.getCategories('/Categories', this.globalObjectsService.currentSelectedPopulationName.value)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        let productsList = this.commonService.getProductsFromVirtualCategory(data);
        this.globalObjectsService.Products.next(productsList);
        this.ngxService.stop('LOAD_CATEGORIES');
      });
  }

  ngOnDestroy(): void {
    this.signalUnsubscribe();
  }

  getScreenView() {
    this.isMobile = window?.innerWidth < this.mobileMaxWidth;
  }

  private navigateToEditorTermsAndConditions(): void {
    this.router.navigate([this.helperService.getBaseUrl() + '/home/self-service-terms-conditions']);
  }

  private navigateToUserDisclaimer(): void {
    this.router.navigate([this.helperService.getBaseUrl() + '/home/self-service-user-disclaimer']);
  }

  private navigateToCampaignIndex(): void {
    this.router.navigate([this.helperService.getBaseUrl() + '/campaign/index']);
  }

  logOut(): void {
    let urL = this.router.url.valueOf();
    if (!urL.includes(this.baseUrl + "/quote") || !this.uiConfig.uiConfiguration.showAlertPopup || (urL.includes("/complete"))) {
      this.authenticationService.logout().subscribe(() => {
        this.helperService.logoutRedirection();
      });
    } else if (this.uiConfig.uiConfiguration.showAlertPopup) {
      this.helperService.logoutRedirection();
    }
  }


  showAfterLoginCheck(): boolean {
    if (!this.helperService.AllowAnonymousAccess() && !this.authenticationService.isLogin) {
      return false;
    }
    return true;
  }

  closemodalcross(statusofclick: boolean) {
    this.isNavbarCollapsed = statusofclick;
  }

  truncate(input: string) {
    if (input && input.length > 10) {
      return input.substring(0, 10) + '...';
    }
    return input;
  }


  clickedDropDown: NgbDropdown;
  closeOtherDropdowns(clickedDropdown: NgbDropdown) {
    this.clickedDropDown = clickedDropdown;
    setTimeout(() => {
      let totalPlanCon = document.querySelectorAll<HTMLElement>(".qContent").length;
      for (let i = 0; i < totalPlanCon; i++) {
        let offsetHeightCn = document.querySelectorAll<HTMLElement>(".qContent")[i].offsetHeight;
        let scrollHeightCn = document.querySelectorAll<HTMLElement>(".qContent")[i].scrollHeight;
        if (scrollHeightCn == offsetHeightCn) {
          document.querySelectorAll<HTMLElement>('.qContent')[i].classList.add("disableTooltip");
        }

      }
    }, 100);

    this.dropdowns.toArray().forEach(el => {
      if (el != clickedDropdown)
        el.close();
    });

    this.keepTheDropDownNavBarOpenWhenScrolling(clickedDropdown);
  }

  /**
   * To handle the custom browser scroll event.
   * Nav drop down getting close when the user clicks on the scroll bar
   * So, Adding some custom events to track the movement and making it open
   */
  keepTheDropDownNavBarOpenWhenScrolling(clickedDropdown: NgbDropdown): void {
    let scrollEventFired: boolean = false;
    try {
      const self = this;
      const eventHandlers = {
        scroll() {
          self.dropDownAutoClose = false;
          scrollEventFired = true;
        },
        mousedown() {
          // 3 Step
          document.addEventListener("scroll", eventHandlers.scroll);
          self.dropDownAutoClose = true;
          scrollEventFired = false;
        },
        mouseup() {
          self.dropDownAutoClose = true;
          if (!scrollEventFired) {
            eventHandlers._clear();
            setTimeout(() => {
              if (clickedDropdown.isOpen()) {
                self.keepTheDropDownNavBarOpenWhenScrolling(clickedDropdown);
              }
            }, 10);
          }
        },
        _clear() {
          document.removeEventListener("mousedown", eventHandlers.mousedown);
          document.removeEventListener("scroll", eventHandlers.scroll);
          document.removeEventListener("mouseup", eventHandlers.mouseup);
        }
      }

      // 1 Step
      document.addEventListener("mousedown", eventHandlers.mousedown);
      // 2 Step
      document.addEventListener("mouseup", eventHandlers.mouseup);
    } catch { }
  }

  ifLogoutUser(decodedUser: any) {
    let isLogoutUser = !this.authenticationService.isLogin && this.analyticsService.verifyDataLayerValue('IsAuthenticated', 'true');

    if (isLogoutUser) {
      this.TID = this.analyticsService.getDataLayerValue('TID');
    } else {
      this.TID = decodedUser.TID;
    }
  }

  updateAnalyticsValues(decodedUser: any) {

    this.ifLogoutUser(decodedUser);

    if (this.TID == Constants.GuidEmpty && this.helperService.getUrlParameter('TID')) {
      this.TID = this.helperService.getUrlParameter('TID');
    }

    let externalTID = this.helperService.getUrlParameter('external_TID') ?? Constants.GuidEmpty;

    let user_info_params = {
      "event": "userinfo-access",
      "IsAuthenticated": this.TID && this.TID != Constants.GuidEmpty,
      "PreferredCulture": decodedUser.PreferredCulture,
      "ClientCode": decodedUser.ClientCode,
    };

    if (decodedUser.IsSso && decodedUser.IsSso != "False") {
      this.analyticsService.updateDataLayer("IsSSO", decodedUser.IsSso);
    }

    let user_additional_info = {};

    user_info_params = {
      ...user_info_params,
    }

    if (this.TID != Constants.GuidEmpty) {
      user_additional_info = {
        "TID": this.TID,
        "externalTID": externalTID,
        "IsImpersonation": decodedUser.IsImpersonation == "True",
        "Ghost": decodedUser.Ghost == "True",
        "RegionalAffliationCode": decodedUser.RegionalAffliationCode ? decodedUser.RegionalAffliationCode : ""
      }
    } else if (this.analyticsService.getDataLayerValue('TID') != '' && this.analyticsService.getDataLayerValue('TID') != Constants.GuidEmpty) {
      user_additional_info = {
        "Loggedout": true
      }
    }

    let utm_params = this.helperService.getUTMParameters();
    let merged_params = { ...user_info_params, ...user_additional_info, ...utm_params };
    if (sessionStorage['externalUserIdentifier']) {
      let externalUserIdParams = {
        "externalUserIdentifier": sessionStorage['externalUserIdentifier']
      }
      merged_params = { ...merged_params, ...externalUserIdParams };
      sessionStorage.removeItem('externalUserIdentifier');
    }
    this.analyticsService.trackCustomEvent(merged_params);
    this.analyticsService.identifyUser(this.TID);
    if (this.TID && this.TID != Constants.GuidEmpty) {
      this.analyticsService.addHeapUserProperties(merged_params);
    }
  }

  private get isOnContactPreferencesPage(): boolean {
    return this.router.url.includes('contactpreferences');
  }

  loadToolBarControls(population?: string): void {
    this.toolbarControlsForMasthead = this.editableMbrSiteToolbarService
      .buildGlobalToolbarControls({
        population: population,
        hideRestrictedItems: this.isOnContactPreferencesPage,
        callBackFn: {
          openPopulationManagement: this.onPopulationClick,
          openMemberSite: this.openMemberSite,
          openSettings: this.openSettings,
          navigateToPopulationManagement: this.navigateToPopulationManagement,
          navigateToPopulationToLanguages: this.navigateToPopulationToLanguages,
          publishTask: this.publishTask,
          libraryItems: this.libraryItems,
          requirementsSets: this.requirementsSets,
          navigateToEditorTermsAndConditions: this.navigateToEditorTermsAndConditions,
          navigateToUserDisclaimer: this.navigateToUserDisclaimer,
          navigateToCampaignIndex: this.navigateToCampaignIndex,
          logOut: this.logOut
        }
      });
  }

  onPopulationClick(): void {
    if (!this.selfServiceService.isEditorFirstTimeProcessCompleted)
      return;

    const modalRef = this.selfServiceService.openModal(SelfServicePopulationSelectorTemplateModalComponent, this.resourceStrings['Aon.SelfService.PopulationPreview'], "md");
    const componentInstance: SelfServicePopulationSelectorTemplateModalComponent = modalRef.componentInstance;

    this.globalObjectsService.compactEmployeeInformation.subscribe(data => {
      if (data && data.populations.length > 0) {
        const populations = this.globalObjectsService.Populations.filter(x => x.recordID == data.populations[0].recordID);
        componentInstance.selectedPopulation = populations[0].name;
      }
    });
    if (!componentInstance.selectedPopulation) {
      componentInstance.selectedPopulation = this.globalObjectsService.currentSelectedPopulationName.value;
    }
    componentInstance.onSubmitPopulation.subscribe({
      next: (data) => {
        this.loadToolBarControls(data.selectedPopulation);
        this.globalObjectsService.currentSelectedPopulationName.next(data.selectedPopulation);
        const selectedPopulationObj = this.globalObjectsService.Populations.find(x => x.name == data.selectedPopulation) ?? null;
        this.ngxService.start('POPULATION_PREVIEW');
        this.selfServiceService.setPopulationPreview(selectedPopulationObj?.recordID ?? null).subscribe({
          next: (result) => {
            this.commonService.getCompactEmployeeInformation()
              .pipe(take(1))
              .subscribe({
                next: res => {
                  this.ngxService.stop('POPULATION_PREVIEW');
                  this.globalObjectsService.compactEmployeeInformation.next(res);
                  this.selfServiceService.onPopulationPreviewChange.next(data.selectedPopulation);
                  modalRef.dismiss();
                }, error: (error) => {
                  componentInstance.onSubmitErrorMessage = this.resourceStrings['Aon.SetPopulation.Error'];
                  this.ngxService.stop('POPULATION_PREVIEW');
                }
              })
            if (result?.data?.uiConfiguration) {
              sessionStorage.setItem('previewUiConfigID', result.data.id.toString());
              this.uiconfigrationService.afterUIConfigurationReceived(result.data);
            }
          },
          error: (error) => {
            componentInstance.onSubmitErrorMessage = this.resourceStrings['Aon.SetPopulation.Error'];
            this.ngxService.stop('POPULATION_PREVIEW');
          }
        });
      }
    })
  }

  openMemberSite(): void {
    const memberSiteUrl = this.helperService.getMemberSiteUrl();
    if (memberSiteUrl) {
      window.open(memberSiteUrl, "_blank");
    }
  }

  publishTask() {
    this.router.navigate([this.baseUrl + "/selfservice/publish-tasks"]);
  }

  requirementsSets() {
    this.router.navigate([this.baseUrl + "/globalbenefitslibrary/requirements-sets"]);
  }

  libraryItems() {
    this.router.navigate([this.baseUrl + "/globalbenefitslibrary/library-items"]);
  }

  navigateToPopulationManagement(): void {
    this.router.navigate([this.baseUrl + '/globalbenefitslibrary/population-management']);
  }

  navigateToPopulationToLanguages(): void {
    this.router.navigate([this.baseUrl + '/globalbenefitslibrary/population-to-languages']);
  }

  openSettings(): void {
    if (!this.selfServiceService.isEditorFirstTimeProcessCompleted)
      return;

    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      ariaLabelledBy: 'ui-config-modal',
      modalDialogClass: 'content-editor-modal'
    };
    ngbModalOptions.container = '#app-modal-anchor';
    const modalRef = this.modalService.open(UiConfigModalComponent, ngbModalOptions);
    modalRef.componentInstance.isGlobalPropertySet = true;
  }

  closeModelAddOverlay(event) {
    if (!event) {
      if (document.querySelector('.bg-overlay')) {
        document.body.removeChild(document.querySelector('.bg-overlay'));
      }
    } else {
      const overlayElement = document.createElement('span');
      overlayElement.className = 'bg-overlay';
      document.body.appendChild(overlayElement);
    }
  }

  onToolbarDropdownState(isOpen: boolean) {
    this.disableDropDownAutoClose = isOpen;
  }
}   
